import { DateType } from "data/types/index";
import { parseDate } from "../utilities/parseHelper";
import { RequestsStates } from "./enums/requestsStates";

/**
 * Данные истории заявок
 */
export class ServerProcessData {

  /**
   * Заголовок.
   */
  public Caption: string = "";

  /**
   * Дата заявки.
   */
  public DateStart: DateType = new Date();

  /**
   * Статус заявки
   */
  public CurrentState: RequestsStates = RequestsStates.None;

  /**
   * Текстовое описание статуса заявки
   */
  public StateDescription: string = '';

  /**
   * Идентификатор операции связанной с заявкой
   */
  public OperationId: number | null = null;

  /**
   * Массив истории статусов заявки
   */
  public StatesHistory: Array<any> = [];

  public Attachments: Array<any> = [];

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.Caption = src.Caption ?? "";
      this.DateStart = parseDate(src.DateStart);
      this.CurrentState = src.СurrentState?.State as RequestsStates;
      this.StateDescription = src.СurrentState?.StateDescription ?? "";
      this.OperationId = src.СurrentState?.OperationId ?? null;
      this.Attachments = src.СurrentState && src.СurrentState.Attachments.length ? src.СurrentState.Attachments : [];
      if (src.States && src.States.length) {
        for (const key in src.States) {
          if (src.States[key]) {
            const item: any = src.States[key];
            this.StatesHistory.push({
              State: item.State as RequestsStates,
              StateDescription: item.StateDescription,
              OperationId: item.OperationId,
              CreateDate: new Date(item.CreateDate)
            });
          }
        }
      }
    }
  }
}
